/*
 * @Description:
 * @LastEditors: wjx
 * @Date: 2021-01-28 23:29:19
 */
import SlideVerify from "../packages/slide-verify/index.js";

const components = [SlideVerify];

const install = function(Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  SlideVerify
};



// WEBPACK FOOTER //
// ./src/lib/index.js